;(function() {
  'use strict'

  service.$inject = ["$transitions", "$window"];
  angular.module('app.page').factory('shareHeightService', service)

  /* @ngInject */
  function service($transitions, $window) {
    var groups = {}

    angular.element($window).on('resize', _.throttle(check, 1000))
    $transitions.onStart(null, reset)

    return {
      register: register,
    }

    function register(name, getter, setter) {
      if (!groups[name]) {
        groups[name] = {
          getters: [],
          setters: [],
        }
      }
      groups[name].getters.push(getter)
      groups[name].setters.push(setter)
      check()
    }

    function check() {
      _.each(groups, function(group) {
        var newHeight

        if (!group.height) {
          // log.debug('set default height zero for group: ', name);
          group.height = 0
        }

        _.each(group.getters, function(get) {
          var height = get()
          if (height > group.height) {
            newHeight = height
            // log.debug('found new height', height);
          }
        })

        if (newHeight) {
          group.height = newHeight
        }

        _.each(group.setters, function(set) {
          set(group.height + 'px')
        })
      })
    }

    function reset() {
      groups = {}
    }
  }
})()
